import { Grid } from '@mui/material'
import { Error, Warning } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useSnackbar, CustomContentProps } from 'notistack'
import React, { forwardRef } from 'react'
import styled from 'styled-components'

import { pxToRem } from '../../libs/style'
import { CloseIcon } from '../../styleguide/icons'
import theme from '../../styleguide/theme'

type InputAlertPopupProps = CustomContentProps & {
	critical: boolean
}

export const CloseButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${pxToRem(24)}rem;
	height: ${pxToRem(24)}rem;
	margin-left: ${theme.spacing(2)};
	cursor: pointer;
`

export const AlertWrapper = styled(Grid)<{ $critical: boolean }>`
	display: flex;
	justify-content: space-between;
	width: ${pxToRem(756)}rem;
	background-color: ${props => (props.$critical ? '#FFE7E7' : '#FFF6E2')};
	border: 1px solid ${props => (props.$critical ? '#F55959' : '#FFB63B')};
	border-radius: ${theme.shape.borderRadius}px;
	padding: ${theme.spacing(2)};
	color: #5c6b82;
	font-size: ${pxToRem(16)}rem;
	line-height: ${pxToRem(21)}rem;
`

const AlertTitle = styled.div<{ $critical: boolean }>`
	color: ${props => (props.$critical ? '#530A0A' : '#704300')};
	padding-bottom: ${theme.spacing(1)};
	font-weight: bold;
`

const InputAlertPopup = forwardRef<HTMLDivElement, InputAlertPopupProps>(
	(props: InputAlertPopupProps, ref: React.ForwardedRef<HTMLDivElement>) => {
		const { t } = useTranslation()
		const { closeSnackbar } = useSnackbar()
		const { id, message, critical } = props

		return (
			<AlertWrapper container ref={ref} $critical={critical}>
				<Grid display={'flex'} item sm={1} justifyContent="center">
					{critical ? <Error color="error" /> : <Warning color="warning" />}
				</Grid>

				<Grid item sm={10}>
					<AlertTitle $critical={critical}>
						{t(`inputAlert.popup.${critical ? 'errorTitle' : 'warningTitle'}`)}
					</AlertTitle>
					<div>{message}</div>
				</Grid>
				<Grid item sm={1}>
					<CloseButton onClick={() => closeSnackbar(id)}>
						<CloseIcon />
					</CloseButton>
				</Grid>
			</AlertWrapper>
		)
	},
)

export default InputAlertPopup
